import { ExistingProvider, FactoryProvider, forwardRef, Provider, Type } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { InputBaseComponent } from '../../models';
import { ErrorStateMatcher as FormInputErrorStateMatcher } from '../../services/error/error-state-matcher';

export class InputProviderFactory {
  public static getProviders(component: Type<InputBaseComponent>, provideValidator?: boolean): Provider[] {
    const providers: Provider[] = [
      InputProviderFactory.getAccessor(component),
      InputProviderFactory.getErrorStateMatcher(),
    ];

    if (provideValidator) {
      providers.push(InputProviderFactory.getValidator(component));
    }

    return providers;
  }

  private static getAccessor(component: Type<InputBaseComponent>): ExistingProvider {
    return {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => component),
    };
  }

  private static getValidator(component: Type<InputBaseComponent>): ExistingProvider {
    return {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => component),
    };
  }

  private static getErrorStateMatcher(): FactoryProvider {
    return {
      provide: ErrorStateMatcher,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      useFactory: FormInputErrorStateMatcher.getInstance,
    };
  }
}
